import { render } from "./widgetLinkOpen.vue?vue&type=template&id=5126ce01"
import script from "./widgetLinkOpen.vue?vue&type=script&lang=js"
export * from "./widgetLinkOpen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__